import { makeStyles } from "@material-ui/core/styles";
import ListSubheader from "@material-ui/core/ListSubheader";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Grid from "@material-ui/core/Grid";
import data from "./listData";
import ActivitySlider from "./ActivitySlider";
import Conditions from "./Conditions";
import { Container, Typography } from "@material-ui/core";

export default function ListComponent() {
  const classes = useStyles();

  return (
    <div className={classes.gridRoot}>
      <Grid container spacing={3}>
        <Grid item xs={12} lg={6}>
          <List
            component='nav'
            aria-labelledby='nested-list-subheader'
            subheader={
              <ListSubheader component='div' id='nested-list-subheader'>
                Cost based on a group of 30px, accommodated in twin rooms
              </ListSubheader>
            }
            className={classes.listRoot}
          >
            {data.map((item) => (
              <ListItem key={item.text}>
                <ListItemIcon className={classes.icon}>
                  {item.icon}
                </ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItem>
            ))}
          </List>
          <Container className={classes.price}>
            <Typography variant='h5' className={classes.priceText}>
              All the above, for just : <strong>€820p.p</strong>
            </Typography>
            <Conditions />
          </Container>
        </Grid>
        <Grid item xs={12} lg={6}>
          <ActivitySlider />
        </Grid>
      </Grid>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  gridRoot: {
    flexGrow: 1,
  },
  listRoot: {
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  icon: {
    color: "#ea5933",
  },
  price: {
    padding: theme.spacing(4),
    border: "2px solid #ea5933",
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
  },
  priceText: {
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.3rem",
    },
  },
}));
